import styled from "styled-components";

export const Container = styled.div`
  justify-content: center;
  display: flex;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(4, 195, 243, 0.56) 0%,
    rgba(28, 117, 188, 0.86) 49.95%,
    rgba(39, 43, 100, 0.81) 100%
  );
  text-align: center;
  white-space: pre;
  padding: 16px;
  border: 2px solid #fff;
  margin-top: 4rem;
  margin-bottom: 0.8rem;
  width: ${(props) => props?.width ?? "inherit"};
  margin-left: ${(props) => props?.marginLeft ?? 0};
`;
